// opervex-frontend/src/Opervex/Tax/index.js

import _Inbound from "./Inbound";

class System {
  #_api;

  constructor(api) {
    this.#_api = api;

    this.Inbound = new _Inbound(this.#_api);
  }
}

export default System;
